module.exports = __webpack_public_path__ + "img/lecture_online2.90aecc10.png";